<template>
  <div class="announcement-modal" v-if="visible" >
  <div class="modal-content">
      <div class="modal-header">
        <h2 class="title">观星树退货地址更新公告！</h2>
        <div class="close-btn" @click="handleClose">X</div>
      </div>
      <div class="modal-body">
        <div class="info-item">
          <span class="label">退货地址：</span>
          <span class="content">浙江省杭州市萧山区瓜沥镇坎山路333号4号楼负一楼(东边电梯+自己店铺名全称)</span>
        </div>
        <div class="info-item">
          <span class="label">收件人姓名：</span>
          <span class="content">剑哥</span>
        </div>
        <div class="info-item">
          <span class="label">手机号：</span>
          <span class="content">填自己的</span>
        </div>
        <div class="info-item">
          <span class="label">备注：</span>
          <span class="content">0571-56125509</span>
        </div>
        <div class="info-item">
          <span class="label">地址详情：</span>
          <span class="content">加上自己店铺名全称方便有问题件可以直接联系商家处理(方便直接分别退货是那个店铺的订单)</span>
        </div>
        <img :src="qrCodeUrl" alt="客服二维码" class="large-qr-img">

      </div>
    </div>


    <!-- <div class="modal-content" style="height: 500px;">
      <div class="modal-header">
        <h2 class="title" style="font-size: 26px;">公告！</h2>
        <div class="close-btn" @click="handleClose">X</div>
      </div>
      <div class="modal-body">
        <div class="info-item">
          <span class="label" style="font-size: 22px;">各位用户：</span>
        </div>
        <div class="info-item">
          <span class="label" style="font-size: 20px;">今天观星树新功能
售后&赔付上线
暂时铺货不能使用，采购正常进行
铺货明天恢复使用。</span>
        </div>


      </div>
    </div> -->

  </div>
</template>

<script>
export default {
  name: 'AnnouncementModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      qrCodeUrl: require('@/assets/images/ggg.png')
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped>
.announcement-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-content {
  background: white;
  width: 95%;
  max-width: 800px;
  border-radius: 8px;
  padding: 30px;
}
.large-qr-img{
  width: 500px;

}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.title {
  color: red;
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  flex: 1;
  margin: 0;
}

.close-btn {
  cursor: pointer;
  font-size: 24px;
  color: #666;
  padding: 5px;
}

.info-item {
  margin-bottom: 20px;
  line-height: 1.8;
  font-size: 16px;
}

.label {
  font-weight: bold;
  color: #333;
  font-size: 16px;
}

.content {
  color: #666;
  font-size: 16px;
}
</style>
